import makeStyles from '@mui/styles/makeStyles';

/**
 * Keep the parent positions table at viewport width when a wide detail
 * panel is expanded; the detail content scrolls horizontally instead.
 */
export const useNavReconPositionsTableLayoutStyles = makeStyles({
  tableRoot: {
    '& .MuiTable-root': {
      tableLayout: 'fixed',
      width: '100%',
    },
    '& .MuiTableHead-root .MuiTableRow-root > .MuiTableCell-root:first-of-type, & .MuiTableBody-root .MuiTableRow-root > .MuiTableCell-root:first-of-type':
      {
        width: '3rem !important',
        maxWidth: '3rem !important',
        minWidth: '3rem !important',
        boxSizing: 'border-box',
        overflow: 'hidden',
      },
    '& .MuiTableBody-root .MuiTableRow-root > .MuiTableCell-root[colspan]': {
      padding: 0,
      width: '100%',
      maxWidth: '100%',
      overflow: 'auto',
    },
  },
});
